import { ReactNode, useEffect, useState } from "react";
import { Droppable, DroppableProps, DroppableProvided, DroppableStateSnapshot } from "react-beautiful-dnd";

type StrictModeDroppableProps = DroppableProps & {
  children: (provided: DroppableProvided, snapshot: DroppableStateSnapshot) => ReactNode;
};

const StrictModeDroppable = ({ children, ...droppableProps }: StrictModeDroppableProps) => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const animationFrameId = requestAnimationFrame(() => setIsEnabled(true));
    return () => {
      cancelAnimationFrame(animationFrameId);
      setIsEnabled(false);
    };
  }, []);

  if (!isEnabled) return null;

  return <Droppable {...droppableProps}>{children}</Droppable>;
};

export default StrictModeDroppable;